import { writable, derived } from 'svelte/store';
import { Action } from '../interfaces/action';
const configuration = writable(undefined);
const configurationProductType = writable(undefined);
const configurationProductIds = writable(undefined);
const configurationProductIdsGroupedByProductType = writable(undefined);
const bundleProductId = writable(undefined);
const sayDuckProductId = writable(undefined);
const filteredProductGroup = writable(undefined);
const selectedProductSummary = writable(undefined);
const selectedIkeaProductSummary = writable(undefined);
const selectedSayDuckOptions = writable({});
const shop = writable(undefined);
const shopCurrency = writable({ currency: 'EUR', symbol: '€' });
const meta = writable(undefined);
const saved = writable(undefined);
const lang = writable('fi');
const newSavedConfigurationId = writable(undefined);
const savedConfigurationPhoto = writable(null);
const selectedSection = writable(null);
const selectedOptions = createSelectedOptions();
const savedOptions = writable(undefined);
const selectedDetails = writable({
    model: '',
    width: '',
    height: '',
    depth: '',
    style: '',
    color: '',
    worktops: '',
    handles: '',
    legs: '',
    colorImage: '',
    handlesImage: '',
    heightImage: '',
    legsImage: '',
    modelImage: '',
    styleImage: '',
    widthImage: '',
    worktopsImage: '',
    totalShopifyPrice: 0,
    totalIkeaPrice: 0,
    hasLegs: false,
    hasSpacerPanels: false,
    ikeaProductList: [],
    shopifyProductList: [],
    frame: ''
});
const loading = writable(true);
const loadingProductActions = writable(false);
const sayDuckModelLoading = writable(true);
const sayDuckPhotoLoading = writable(false);
const toggleFormSuccess = writable(false);
const togglePopup = writable({ show: false, content: '' });
const toast = writable({
    show: false,
    content: '',
    specialCaseContent: '',
    duration: 1000
});
const shouldPerformScroll = writable(false);
const slideAnimation = writable({ shouldAnimate: false, type: '', duration: 400 });
const bundle = derived(selectedOptions, ($selectedOptions) => {
    const keys = Object.keys($selectedOptions);
    if (keys.length) {
        // Calculate new byndle
        console.log('Calculating new bundle !!');
    }
    return {};
});
const hasSpecialCase = writable(false);
function createSelectedOptions() {
    const { subscribe, update, set } = writable({});
    return {
        subscribe,
        selectOption(sectionId, optionId) {
            return update((curr) => (Object.assign(Object.assign({}, curr), { [sectionId]: optionId })));
        },
        init(options) {
            set(options);
        },
    };
}
const action = writable(Action.INFO);
export { lang, configuration, selectedOptions, selectedSection, bundle, loading, sayDuckModelLoading, sayDuckPhotoLoading, action, shop, shopCurrency, meta, saved, savedOptions, newSavedConfigurationId, savedConfigurationPhoto, toggleFormSuccess, toast, shouldPerformScroll, filteredProductGroup, selectedProductSummary, selectedIkeaProductSummary, configurationProductIds, configurationProductIdsGroupedByProductType, loadingProductActions, selectedDetails, selectedSayDuckOptions, slideAnimation, configurationProductType, togglePopup, hasSpecialCase };
